type NewElementType = {
  href?: string;
};

export const preventGoogleFontsLoading = () => {
  const head = document.getElementsByTagName('head')[0];

  // Save the original method
  const insertBefore = head.insertBefore;

  // @ts-ignore
  head.insertBefore = function (newElement: NewElementType, referenceElement: Element | null) {
    if (newElement.href) {
      try {
        const parsed = new URL(newElement.href, window.location.href);
        if (parsed.hostname === 'fonts.googleapis.com' && parsed.pathname.startsWith('/css')) {
          return;
        }
      } catch {
        console.warn('Failed to parse URL:');
      }
    }

    insertBefore.call(head, newElement, referenceElement);
  };
};
